import { Injectable } from "@angular/core";
import { apiPrefix } from "src/constants/api-prefix";
import { HttpService } from "src/services/http.service";

@Injectable({
  providedIn: "root",
})
export class MasterDataApiService {
  private codeTypesUrl = "/v1/admin/master/types";
  private codeMastersUrl = "/v1/admin/master/code-master";
  private codeMastersTagUrl = "/v1/master/types/list/tags";
  private codeMastersTagUrlV2 = "/v2/master/types/list/tags";
  private getCodeMastersSectorsUrl = "v1/master/types/list/sectors/";

  //  7/themes
  constructor(private httpService: HttpService) {}

  createCodeType(CodeTypeBody: any) {
    return this.httpService.postRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}`,
      CodeTypeBody
    );
  }

  createCodeMaster(codeTypeId: string, CodeMasterBody: any) {
    return this.httpService.postRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}/code-master/${codeTypeId}`,
      CodeMasterBody
    );
  }

  deleteCodeTypeById(id: any) {
    return this.httpService.deleteRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}/delete/${id}`
    );
  }

  deleteCodeMasterById(id: any) {
    return this.httpService.deleteRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeMastersUrl}/delete/${id}`
    );
  }

  updateCodeTypeById(id: any, bodyObj: any) {
    return this.httpService.patchRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}/update/${id}`,
      bodyObj,
      undefined,
      undefined,
      true
    );
  }

  updateCodeMasterById(id: any, bodyObj: any) {
    return this.httpService.patchRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeMastersUrl}/update/${id}`,
      bodyObj,
      undefined,
      undefined,
      true
    );
  }

  getCodeTypeList(params: any) {
    return this.httpService.getRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}`,
      params,
      undefined,
      true
    );
  }

  getCodeMastersByCodeType(codeTypeId: string, params: any) {
    return this.httpService.getRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}/list/${codeTypeId}`,
      params,
      undefined,
      true
    );
  }

  getCodeMastersTags() {
    return this.httpService.getRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeMastersTagUrl}`
    );
  }

  getCodeMastersTagsV2() {
    return this.httpService.getRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeMastersTagUrlV2}`
    );
  }

  createSectorTheme(CodeMasterBody: any) {
    return this.httpService.postRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}/code-master/themes`,
      CodeMasterBody
    );
  }

  getAllThemeList(parentId: number) {
    return this.httpService.getRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}/${this.getCodeMastersSectorsUrl}${parentId}/themes`,
      undefined,
      undefined,
      true
    );
  }

  getThemeList(params: any) {
    return this.httpService.getRequest(
      `${apiPrefix.ADMIN_CONFIG_SERVICE_PREFIX}${this.codeTypesUrl}/list/themes`,
      params,
      undefined,
      true
    );
  }
}
